exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-person-button{\n  margin-left: 10px;\n}\n.icon-space {\n  margin-right: 10px;\n  margin-bottom: 0px;\n  padding-right: 10px;\n  padding-bottom: 0px;\n}\n.edit-font {\n  font-size: 20px;\n}\n.secondary.v-card.v-sheet.theme--light {\n    flex: 1 1 auto!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5164f0e6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/People/AddPerson.vue
// module id = m02A
// module chunks = 1